export enum ADMISSION_REQUEST_TYPE {
    UPDATE_USER_INFO = 'updateUserInfoRequest',
    ADD = 'addNewUserRequest',
    DEACTIVATE = 'deActivateUserRequest',
    ACTIVATE = 'activateUserRequest',
    DEACTIVATE_CALL_CENTER_USER = 'deActivateCallCenterUser',
    ACTIVATE_CALL_CENTER_USER = 'activateCallCenterUser'
}
export enum ADMISSION_BACKEND_REQUEST_TYPE {
    UPDATE_USER_INFO = 'UPDATE_USER_INFO',
    ADD = 'ADD',
    DEACTIVATE = 'DEACTIVATE',
    ACTIVATE = 'ACTIVATE',
    DEACTIVATE_CALL_CENTER_USER = 'DEACTIVATE_CALL_CENTER_USER',
    ACTIVATE_CALL_CENTER_USER = 'ACTIVATE_CALL_CENTER_USER'
}

export enum ADMISSION_REQUEST_FORM_TYPE {
    TUWAIQ = 'tuwaiq',
    CALL_CENTER = 'callCenter',
    BOTH = 'both'
}
